$(document).ready(function() {
  $('.product-form__submit').click('cart-hidden');
});

$(document).ready(function () {
  $('.price-text-wrapper .price-item').each(function() {
    var priceString = $(this).text();
    $(this).html("<span style='color: lime; font-size: 24px; color: rgba(0, 0, 0, 0.25); line-height: 29px; font-weight: 600;'>" + priceString.charAt(0) + "</span>" + priceString.substring(1, priceString.length));
  });
});

if($("#file_upload_on_this").length > 0){
  $("#file_upload_on_this").on("change", function (event) {
    $('label[for="file_upload_on_this"]').removeClass('red');
    $('label[for="file_upload_on_this"] .upload-here-text').text(event.target.files[0].name);
  });
}

$(document).ready(function(){
  window.produ_main_for = $('.slider-for');
  window.produ_main_for.slick({
    slidesToShow: 1, slidesToScroll: 1, loop: true,
    prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 475 475.467"><path d="M237.965 475.465.235 237.735 237.964 0l15.07 15.066L30.367 237.734l222.668 222.664z" fill="#7d7d7d"/></svg></div>',
    nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 475 475.467"><path d="M237.965 475.465.235 237.735 237.964 0l15.07 15.066L30.367 237.734l222.668 222.664z" fill="#7d7d7d"/></svg></div>',
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 4, slidesToScroll: 1, asNavFor: '.slider-for',
    loop: true, arrows: false, focusOnSelect: true
  });
});